import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BranchListProps } from '../../models/component'
import * as branchActions from '../../redux/actions/branch.action'
import { RootReducers } from '../../redux/reducers'

export const BranchList: React.VFC<BranchListProps> = ({
  agentData,
  onChange,
  isGetBranchId = false,
  branchId,
  ...otherProps
}) => {
  const dispatch = useDispatch()
  const branchData = useSelector((state: RootReducers) => state.branchReducer)
  const [choice, setChoice] = useState(agentData.branchName)
  useEffect(() => {
    if (isGetBranchId) setChoice(branchId)
    if (agentData.isBranchStaff) dispatch(branchActions.getBranch())
  }, [])
  const staffBranchList = () => {
    return (
      branchData.data &&
      branchData.data.map((item: any, i: any) => {
        return (
          <option key={i} value={isGetBranchId ? item.id : item.name}>
            {item.name}
          </option>
        )
      }, this)
    )
  }

  const agentBranchList = () => {
    return (
      <option key={'1'} value={agentData.branchName}>
        {agentData.branchName}
      </option>
    )
  }

  const branchList = () => {
    if (agentData.isBranchStaff) return staffBranchList()
    return agentBranchList()
  }

  const handleOnChangeLits = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange?.(e)
    setChoice(e.target.value)
  }
  return (
    <select
      disabled={!isGetBranchId}
      className={`field-input`}
      name="branchName"
      value={choice}
      onChange={e => {
        handleOnChangeLits(e)
      }}
      {...otherProps}
    >
      {branchList()}
    </select>
  )
}
